import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import React from 'react';

const PlayersTableColumns = (currencyCode: string) => {
    const { t } = useTranslation();

    return [
        {
            title: t('id'),
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: t('playerId'),
            dataIndex: 'playerId',
            key: 'playerId',
            render: (text: string) => <Link to={`/casino/players/null/${text}`}>{text}</Link>,
            sorter: true,
        },
        {
            title: t('receivedAt'),
            dataIndex: 'receivedAt',
            key: 'receivedAt',
            sorter: true,
        },
        {
            title: () => (
                <span className="table-title__span">
                    {t('totalBet')}
                    <span>{currencyCode}</span>
                </span>
            ),
            dataIndex: 'totalBet',
            key: 'totalBet',
            sorter: true,
        },
        {
            title: () => (
                <span className="table-title__span">
                    {t('totalWin')}
                    <span>{currencyCode}</span>
                </span>
            ),
            dataIndex: 'totalWin',
            key: 'totalWin',
            sorter: true,
        },
        {
            title: 'Played Features',
            dataIndex: 'roundsPlayed',
            key: 'roundsPlayed',
        },
        {
            title: t('lastRoundDate'),
            dataIndex: 'lastRoundDate',
            key: 'lastRoundDate',
        },
        {
            title: t('status'),
            dataIndex: 'status',
            key: 'status',
        },
    ];
};

export default PlayersTableColumns;
